import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BASE}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('mm_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiError(detail) {  if (detail == null) return 'Something went wrong. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).join(' ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}

export function mediaUrl(value) {
  if (!value) return '';
  if (/^https?:\/\//i.test(value)) return value;
  // Local assets bundled in the frontend public folder are served from the site origin.
  if (/^\/(transform|home|netrakshak|tlm|videos|video-thumbs|docs)\//.test(value)) return value;
  return `${BASE}${value.startsWith('/') ? '' : '/'}${value}`;
}

export async function uploadImage(file) {
  const body = new FormData();
  body.append('file', file);
  const { data } = await api.post('/media', body, { headers: { 'Content-Type': 'multipart/form-data' } });
  return data;
}
